/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ActivityCountDto } from '../models/activity-count-dto';
import { KakaoAccountDto } from '../models/kakao-account-dto';
import { PaginationDto } from '../models/pagination-dto';
import { userControllerCountMyActivity } from '../fn/user/user-controller-count-my-activity';
import { UserControllerCountMyActivity$Params } from '../fn/user/user-controller-count-my-activity';
import { userControllerCreate } from '../fn/user/user-controller-create';
import { UserControllerCreate$Params } from '../fn/user/user-controller-create';
import { userControllerDelete } from '../fn/user/user-controller-delete';
import { UserControllerDelete$Params } from '../fn/user/user-controller-delete';
import { userControllerFindAll } from '../fn/user/user-controller-find-all';
import { UserControllerFindAll$Params } from '../fn/user/user-controller-find-all';
import { userControllerFindById } from '../fn/user/user-controller-find-by-id';
import { UserControllerFindById$Params } from '../fn/user/user-controller-find-by-id';
import { userControllerFindByNameAndTel } from '../fn/user/user-controller-find-by-name-and-tel';
import { UserControllerFindByNameAndTel$Params } from '../fn/user/user-controller-find-by-name-and-tel';
import { userControllerFindByUserIdAndNameAndTel } from '../fn/user/user-controller-find-by-user-id-and-name-and-tel';
import { UserControllerFindByUserIdAndNameAndTel$Params } from '../fn/user/user-controller-find-by-user-id-and-name-and-tel';
import { userControllerGetKakaoAccount } from '../fn/user/user-controller-get-kakao-account';
import { UserControllerGetKakaoAccount$Params } from '../fn/user/user-controller-get-kakao-account';
import { userControllerLogin } from '../fn/user/user-controller-login';
import { UserControllerLogin$Params } from '../fn/user/user-controller-login';
import { userControllerLogout } from '../fn/user/user-controller-logout';
import { UserControllerLogout$Params } from '../fn/user/user-controller-logout';
import { userControllerMe } from '../fn/user/user-controller-me';
import { UserControllerMe$Params } from '../fn/user/user-controller-me';
import { userControllerSearch } from '../fn/user/user-controller-search';
import { UserControllerSearch$Params } from '../fn/user/user-controller-search';
import { userControllerTooggleBlock } from '../fn/user/user-controller-tooggle-block';
import { UserControllerTooggleBlock$Params } from '../fn/user/user-controller-tooggle-block';
import { userControllerUnlink } from '../fn/user/user-controller-unlink';
import { UserControllerUnlink$Params } from '../fn/user/user-controller-unlink';
import { userControllerUpdate } from '../fn/user/user-controller-update';
import { UserControllerUpdate$Params } from '../fn/user/user-controller-update';
import { userControllerUpdatePassword } from '../fn/user/user-controller-update-password';
import { UserControllerUpdatePassword$Params } from '../fn/user/user-controller-update-password';
import { UserDto } from '../models/user-dto';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userControllerMe()` */
  static readonly UserControllerMePath = '/api/users/me';

  /**
   * 자신의 정보 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerMe$Response(params?: UserControllerMe$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return userControllerMe(this.http, this.rootUrl, params, context);
  }

  /**
   * 자신의 정보 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerMe(params?: UserControllerMe$Params, context?: HttpContext): Observable<UserDto> {
    return this.userControllerMe$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerCountMyActivity()` */
  static readonly UserControllerCountMyActivityPath = '/api/users/count-my-activity';

  /**
   * 내 활동 내역 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerCountMyActivity()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerCountMyActivity$Response(params?: UserControllerCountMyActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityCountDto>>> {
    return userControllerCountMyActivity(this.http, this.rootUrl, params, context);
  }

  /**
   * 내 활동 내역 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerCountMyActivity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerCountMyActivity(params?: UserControllerCountMyActivity$Params, context?: HttpContext): Observable<Array<ActivityCountDto>> {
    return this.userControllerCountMyActivity$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ActivityCountDto>>): Array<ActivityCountDto> => r.body)
    );
  }

  /** Path part for operation `userControllerSearch()` */
  static readonly UserControllerSearchPath = '/api/users/search';

  /**
   * User 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerSearch$Response(params: UserControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginationDto>> {
    return userControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * User 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerSearch(params: UserControllerSearch$Params, context?: HttpContext): Observable<PaginationDto> {
    return this.userControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginationDto>): PaginationDto => r.body)
    );
  }

  /** Path part for operation `userControllerFindAll()` */
  static readonly UserControllerFindAllPath = '/api/users';

  /**
   * 모든 User 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindAll$Response(params: UserControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserDto>>> {
    return userControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 User 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindAll(params: UserControllerFindAll$Params, context?: HttpContext): Observable<Array<UserDto>> {
    return this.userControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserDto>>): Array<UserDto> => r.body)
    );
  }

  /** Path part for operation `userControllerCreate()` */
  static readonly UserControllerCreatePath = '/api/users';

  /**
   * 회원 가입.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerCreate$Response(params: UserControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return userControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 회원 가입.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerCreate(params: UserControllerCreate$Params, context?: HttpContext): Observable<UserDto> {
    return this.userControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerDelete()` */
  static readonly UserControllerDeletePath = '/api/users';

  /**
   * User 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerDelete$Response(params: UserControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return userControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * User 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerDelete(params: UserControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    return this.userControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userControllerGetKakaoAccount()` */
  static readonly UserControllerGetKakaoAccountPath = '/api/users/kakao-account';

  /**
   * 카카오 계정 정보 조회.
   *
   * 카카오 로그인를 통해 발급받은 토큰을 이용해 카카오 계정 정보를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerGetKakaoAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetKakaoAccount$Response(params: UserControllerGetKakaoAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<KakaoAccountDto>> {
    return userControllerGetKakaoAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * 카카오 계정 정보 조회.
   *
   * 카카오 로그인를 통해 발급받은 토큰을 이용해 카카오 계정 정보를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerGetKakaoAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetKakaoAccount(params: UserControllerGetKakaoAccount$Params, context?: HttpContext): Observable<KakaoAccountDto> {
    return this.userControllerGetKakaoAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<KakaoAccountDto>): KakaoAccountDto => r.body)
    );
  }

  /** Path part for operation `userControllerFindByNameAndTel()` */
  static readonly UserControllerFindByNameAndTelPath = '/api/users/find-id';

  /**
   * 회원 아이디 찾기.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerFindByNameAndTel()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindByNameAndTel$Response(params: UserControllerFindByNameAndTel$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return userControllerFindByNameAndTel(this.http, this.rootUrl, params, context);
  }

  /**
   * 회원 아이디 찾기.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerFindByNameAndTel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindByNameAndTel(params: UserControllerFindByNameAndTel$Params, context?: HttpContext): Observable<UserDto> {
    return this.userControllerFindByNameAndTel$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerFindByUserIdAndNameAndTel()` */
  static readonly UserControllerFindByUserIdAndNameAndTelPath = '/api/users/find-password';

  /**
   * 회원 비밀번호 찾기.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerFindByUserIdAndNameAndTel()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindByUserIdAndNameAndTel$Response(params: UserControllerFindByUserIdAndNameAndTel$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return userControllerFindByUserIdAndNameAndTel(this.http, this.rootUrl, params, context);
  }

  /**
   * 회원 비밀번호 찾기.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerFindByUserIdAndNameAndTel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindByUserIdAndNameAndTel(params: UserControllerFindByUserIdAndNameAndTel$Params, context?: HttpContext): Observable<UserDto> {
    return this.userControllerFindByUserIdAndNameAndTel$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerLogout()` */
  static readonly UserControllerLogoutPath = '/api/users/logout';

  /**
   * 로그아웃.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerLogout()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerLogout$Response(params?: UserControllerLogout$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userControllerLogout(this.http, this.rootUrl, params, context);
  }

  /**
   * 로그아웃.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerLogout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerLogout(params?: UserControllerLogout$Params, context?: HttpContext): Observable<void> {
    return this.userControllerLogout$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userControllerFindById()` */
  static readonly UserControllerFindByIdPath = '/api/users/{id}';

  /**
   * User id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindById$Response(params: UserControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return userControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * User id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerFindById(params: UserControllerFindById$Params, context?: HttpContext): Observable<UserDto> {
    return this.userControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerUpdate()` */
  static readonly UserControllerUpdatePath = '/api/users/{id}';

  /**
   * User 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdate$Response(params: UserControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return userControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * User 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdate(params: UserControllerUpdate$Params, context?: HttpContext): Observable<UserDto> {
    return this.userControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerLogin()` */
  static readonly UserControllerLoginPath = '/api/users/login';

  /**
   * 로그인.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerLogin$Response(params: UserControllerLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return userControllerLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * 로그인.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerLogin(params: UserControllerLogin$Params, context?: HttpContext): Observable<UserDto> {
    return this.userControllerLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerTooggleBlock()` */
  static readonly UserControllerTooggleBlockPath = '/api/users/toggle-block/{id}';

  /**
   * User 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerTooggleBlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerTooggleBlock$Response(params: UserControllerTooggleBlock$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return userControllerTooggleBlock(this.http, this.rootUrl, params, context);
  }

  /**
   * User 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerTooggleBlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerTooggleBlock(params: UserControllerTooggleBlock$Params, context?: HttpContext): Observable<UserDto> {
    return this.userControllerTooggleBlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerUpdatePassword()` */
  static readonly UserControllerUpdatePasswordPath = '/api/users/update-password';

  /**
   * User 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdatePassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdatePassword$Response(params: UserControllerUpdatePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return userControllerUpdatePassword(this.http, this.rootUrl, params, context);
  }

  /**
   * User 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdatePassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userControllerUpdatePassword(params: UserControllerUpdatePassword$Params, context?: HttpContext): Observable<UserDto> {
    return this.userControllerUpdatePassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userControllerUnlink()` */
  static readonly UserControllerUnlinkPath = '/api/users/unlink';

  /**
   * 카카오 연동 해제.
   *
   * 카카오 연동을 해제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUnlink()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerUnlink$Response(params: UserControllerUnlink$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userControllerUnlink(this.http, this.rootUrl, params, context);
  }

  /**
   * 카카오 연동 해제.
   *
   * 카카오 연동을 해제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUnlink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerUnlink(params: UserControllerUnlink$Params, context?: HttpContext): Observable<void> {
    return this.userControllerUnlink$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
